<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :title="'활동 내역'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex: 1; overflow-y: hidden;">
            <InfinityScroll :handle-next-page="handleNextPage" :is-enable-next-page-handle="isEnableNextPageHandle" :refresh-action="refresh" style="height: 100%;">
                <div style="padding: 0 12px;">
                    <div v-for="each, i in recentActivity" :key="i + 'recent_active'" style="border-bottom: 1px solid #f5f5f5; padding: 15px 0;">
                        <RecentActivityWrap :recentActivityEach="each"></RecentActivityWrap>
                    </div>
                </div>
            </InfinityScroll>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import RecentActivityWrap from '@/components/common/RecentActivityWrap'
import InfinityScroll from '@/components/common/InfinityScroll'

export default {
    name: 'ActivityHistory',
    components: {
        MercenaryHeader, RecentActivityWrap, InfinityScroll
    },
    data() {
        return {
            recentActivity: [],
            page: 1,
            isEnableNextPageHandle: true
        }
    },
    created() {
        this.getMyActivityHistory()
    },
    methods: {
        async getMyActivityHistory() {
            this.isEnableNextPageHandle = false
            
            const res = await this.$Axios.get('/api/membership/recent_activity', {
                params: { page: this.page }
            })

            const recentActivity = res.data.recent_activity

            if (recentActivity.length > 0) {
                this.isEnableNextPageHandle = true
                this.recentActivity = [...this.recentActivity, ...recentActivity]
            }
        },
        handleNextPage() {
            this.page++
            this.getMyActivityHistory()
        },
        refresh() {
            this.recentActivity = []
            this.page = 1
            this.getMyActivityHistory()
        }
    }
    
}
</script>

<style scoped>
    
</style>